import { useState, useEffect } from "react";
import { API, ADMIN_SECRET } from "../adminUtils";
import "../admin-base.css";
import "../admin-layout.css";
import "../admin-controls.css";
import "../admin-responsive.css";
import "./checkInTab.css";

function CheckInLinkGenerator() {
  const [classes, setClasses] = useState([]);
  const [classId, setClassId] = useState("");
  const [date, setDate]       = useState(new Date().toISOString().slice(0,10));
  const link = classId ? `${window.location.origin}/checkin?classId=${classId}&date=${date}` : null;
  const DAYS = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

  useEffect(() => {
    fetch(`${API}/schedule/classes`, { headers: { Authorization: ADMIN_SECRET } })
      .then(r => r.json())
      .then(d => setClasses(d.classes ?? []));
  }, []);

  return (
    <div style={{display:"flex", flexDirection:"column", gap:"1rem", maxWidth:"480px"}}>
      <div className="adm-field-group">
        <label className="adm-label">Class</label>
        <select className="adm-input" value={classId} onChange={e => setClassId(e.target.value)}>
          <option value="">— select a class —</option>
          {classes.map(c => (
            <option key={c.id} value={c.id}>{c.title} — {DAYS[c.dayOfWeek] ?? c.dayOfWeek} {c.time}</option>
          ))}
        </select>
      </div>
      <div className="adm-field-group">
        <label className="adm-label">Date</label>
        <input className="adm-input" type="date" value={date} onChange={e => setDate(e.target.value)} />
      </div>
      {link && (
        <div style={{background:"var(--color-grey-100)", border:"1px solid var(--color-grey-200)",
          borderRadius:"8px", padding:"1rem"}}>
          <p style={{fontSize:"0.8rem", color:"var(--color-grey-400)", marginBottom:"0.5rem"}}>Kiosk link:</p>
          <a href={link} target="_blank" rel="noopener noreferrer"
            style={{fontSize:"0.85rem", color:"var(--color-tertiary)", wordBreak:"break-all"}}>
            {link}
          </a>
          <button className="adm-btn-ghost-sm" style={{marginTop:"0.75rem", display:"block"}}
            onClick={() => navigator.clipboard.writeText(link)}>
            Copy link
          </button>
        </div>
      )}
    </div>
  );
}

export default function CheckInTab() {
  return (
    <div className="adm-tab-content">
      <p style={{marginBottom:"1rem", color:"var(--color-grey-400)", fontSize:"0.9rem"}}>
        Open the check-in screen on an iPad or phone at the studio entrance.
        Students tap their name to check in.
      </p>
      <p style={{marginBottom:"0.5rem", fontSize:"0.85rem", color:"var(--color-grey-400)"}}>
        Select a class and date to generate a kiosk link:
      </p>
      <CheckInLinkGenerator />
    </div>
  );
}